<template>
  <default-layout>
    <section slot="content">
      <template v-if="$vuetify.breakpoint.xsOnly">
        <v-carousel :cycle="true" height="auto">
          <template v-for="(item, i) in items">
            <template v-if="item.type == 100">
              <v-carousel-item :key="i">
                <v-img :src="item.image" height="auto" lazy-src="https://firebasestorage.googleapis.com/v0/b/dino-toys.appspot.com/o/img%2Fbanners%2Fbanner_header_cel_default.jpg?alt=media" @click="redirect(item.group)">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="#1b74e4"
                        size="50"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-carousel-item>
            </template>
          </template>
        </v-carousel>
      </template>
      <template v-else>
        <v-carousel :cycle="true" height="auto" type="card">
          <template v-for="(item, i) in items">
            <template v-if="item.type == 1">
              <v-carousel-item :key="i">
                <v-img :src="item.image" height="auto" lazy-src="https://firebasestorage.googleapis.com/v0/b/dino-toys.appspot.com/o/img%2Fbanners%2Fbanner_header_default.jpg?alt=media" @click="redirect(item.group)">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="#1b74e4"
                        size="50"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-carousel-item>
            </template>
          </template>
        </v-carousel>
      </template>

      <v-container fluid>
        <v-row justify="center">
          <v-col cols="12" lg="8" md="10" sm="12" xs="12">
            <v-row no-gutters align="center" justify="center">
              <template v-if="$vuetify.breakpoint.xsOnly">
                <template v-for="body in bodyList">
                  <template v-if="body.type == 100">
                    <v-col cols="12" md="12" class="pt-8">
                      <v-card class="pa-2 rounded" style="border: 0" outlined elevation="0" height="100%">
                        <v-img :src="body.image" @click="redirect(body.group)"></v-img>
                      </v-card>
                    </v-col>
                  </template>
                </template>
              </template>
              <template v-else>
                <template v-for="body in bodyList">
                  <template v-if="body.type == 1">
                    <v-col cols="12" md="12" class="pt-8">
                      <v-card class="pa-2 rounded" style="border: 0" outlined elevation="0" height="100%">
                        <v-img :src="body.image" @click="redirect(body.group)"></v-img>
                      </v-card>
                    </v-col>
                  </template>
                </template>
              </template>
            </v-row>
          </v-col>
        </v-row>
      </v-container>


      <template v-for="groupRow in footerList">
        <v-container fluid>
          <v-row justify="center" align="center">
            <v-col cols="12" lg="12" md="12" sm="12" xs="12">
              <v-row no-gutters align="center" justify="center">
                <v-col cols="12" md="8">
                  <v-slider
                    readonly
                    value="100"
                    :label="groupRow.title"
                    thumb-color="primary"
                    color='primary'
                  >
                  </v-slider>
                </v-col>
              </v-row>
              <v-row align="center" justify="center" class="mt-n6">
                <v-col cols="12" md="8" align="center" justify="center">
                  <template v-if="$vuetify.breakpoint.xsOnly">
                    <v-carousel :cycle="true" hide-delimiter-background hide-delimiters height="300" width="250">
                      <template v-for="(body, i) in groupRow.list">
                        <v-carousel-item :key="i" @click="redirect(body.group)" reverse-transition="fade-transition" transition="fade-transition">
                          <v-img height="300" width="250" eager :src="body.image" @click="redirect(body.group)"></v-img>
                        </v-carousel-item>
                      </template>
                    </v-carousel>
                  </template>
                  <template v-else>
                    <v-slide-group multiple show-arrows="always" outlined elevation="0">
                      <v-row justify="center" align="center" class="my-1">
                        <v-slide-item v-for="body in groupRow.list" :key="body.id" v-slot="{ active, toggle }">
                          <v-card
                            style="border: 0px;"
                            outlined elevation="0"
                            class="ma-3"
                            height="300"
                            width="250"
                            min-width="250"
                            @click="toggle"
                          >
                            <v-img eager :src="body.image" @click="redirect(body.group)"></v-img>
                          </v-card>
                        </v-slide-item>
                      </v-row>
                    </v-slide-group>
                  </template>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <v-container fluid>
        <v-row justify="center" class="mt-6">
          <v-col cols="12" md="8" xs="12">
            <v-row no-gutters>
              <template v-for="label in labels">
                <v-col cols="6" md="3" xs="6">
                  <v-card class="text-center" style="border: 0" outlined elevation="0">
                    <!-- <template v-if="label.icon == 'mdi-whatsapp'"> -->
                      <!-- <v-icon size="40px" color="primary"
                                @click="goWhatsapp()">
                        {{ label.icon }}
                      </v-icon>
                      <v-card-text
                                @click="goWhatsapp()">
                        {{ label.name }}
                      </v-card-text>
                    </template>
                    <template v-else> -->
                      <v-icon size="40px" color="primary">
                        {{ label.icon }}
                      </v-icon>
                      <v-card-text>
                        {{ label.name }}
                        <template v-if="label.icon == 'mdi-whatsapp'">
                          <v-btn
                                color="primary"
                                elevation="2"
                                target="_blank"
                                :href="goWhatsapp()"
                                block
                              >
                                987839662
                              </v-btn>
                        </template>
                      </v-card-text>
                    <!-- </template> -->
                  </v-card>
                </v-col>
              </template>
            </v-row>
          </v-col>
        </v-row>
      </v-container>

      <template>
        <div class="text-center">
          <v-overlay color="#4181FF" :opacity="opacity" :value="overlay">
            <v-card class="text-center" style="border: 0; z-index: 999" outlined elevation="0" width="200">
              <img :src="require('@/assets/overlay.jpg')" style="width: 100%;">
            </v-card>
            <br>
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="white"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </template>

    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'

  export default {
    name: 'HomePage',
    components: {
      DefaultLayout
    },
    metaInfo() {
      return {
        title: 'Dino-Toys.com ¡Las mejores ofertas en miles de productos!',
        meta: [
          { name: 'description', content: 'Lo último en tendencias en Juguetes y Ropas, con estilo y al mejor precio.' },
          { property: 'og:title', content: 'Dino-Toys.com | Lo mejor en Juguete, Moda y más' },
          { property: 'og:site_name', content: 'Dino Toys' },
          { property: 'og:description', content: 'Compra en Dino Toys lo que necesitas para el pequeño del hogar, divertirte en casa con lo último en tendencia en Juguetes, Ropa, con estilo y al mejor precio..' },
          { property: 'og:url', content: 'https://www.dino-toys.com/' },
          { property: 'og:image', content: 'https://firebasestorage.googleapis.com/v0/b/dino-toys.appspot.com/o/img%2Flogos%2Flogo_meta.jpg?alt=media&token=4a5db43f-4ff5-4d47-99e4-bea4fab9432b' }
        ]
      }
    },
    data () {
      return {
        items: [],
        bodyList: [],
        footerList: [],
        labels: [
          { icon: 'lock', name: 'Compra fácil y seguro' },
          { icon: 'local_shipping', name: 'Despacho a domicilio' },
          { icon: 'mdi-whatsapp', name: 'Chatea con nosotros' },
          { icon: 'local_offer', name: 'Promociones a tu medida' }
        ],
        overlay: false,
        opacity: 1,
      }
    },
    beforeCreate() {
      axios.get(process.env.DINO.PATH.GET_HOME)
        .then(response => {
          this.items = response.data.header;
          this.bodyList = response.data.body;
          this.footerList = response.data.footer;
          localStorage.setItem('header', JSON.stringify(response.data.header));
          localStorage.setItem('body', JSON.stringify(response.data.body));
          localStorage.setItem('footer', JSON.stringify(response.data.footer));
        })
        .catch(err => {
          this.items = JSON.parse(localStorage.getItem('header'));
          this.bodyList = JSON.parse(localStorage.getItem('body'));
          this.footerList = JSON.parse(localStorage.getItem('footer'));
        });
    },
    methods: {
      /*getHome() {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.GET_HOME)
        .then(response => {
          this.items = response.data.header;
          this.bodyList = response.data.body;
          this.footerList = response.data.footer;
          localStorage.setItem('header', JSON.stringify(response.data.header));
          localStorage.setItem('body', JSON.stringify(response.data.body));
          localStorage.setItem('footer', JSON.stringify(response.data.footer));
        })
        .catch(err => {
          this.items = JSON.parse(localStorage.getItem('header'));
          this.bodyList = JSON.parse(localStorage.getItem('body'));
          this.footerList = JSON.parse(localStorage.getItem('footer'));
        })
        .then(() => {
          this.overlay = false;
        });
      },*/
      goWhatsapp () {
        const urlWhatsapp = `*DINO!* - Quiero información de sus productos.%0D%0A%0D%0A_%C2%A1+Gracias+%21_`;
        return `https://api.whatsapp.com/send?phone=51987839662&text=${urlWhatsapp}`;
      },

      redirect: function(group) {
        this.$router.push({ name:'Products', query: { q: group, orderBy: 'OrderByReleaseDateDESC', page: 1 } }).catch(err => {});
      }
    },
    mounted: function() {
      // this.getHome();
    }
  }
</script>
<style scoped>
  >>>.v-input__slider label {
    font: oblique bold cursive;
    font-weight: 800;
    color: #011135;
  }

  >>>.v-slider__thumb {
    height: 10px;
    width: 10px;
  }

  >>>.v-slider--horizontal .v-slider__track-container {
    height: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/views/HomePage.vue